document.addEventListener('DOMContentLoaded', () => {
  const heroSliders = [];
  const heroes = document.querySelectorAll('[data-hero]');
  const playButtons = document.querySelectorAll('[data-hero-slide-play]')
  let options = {
    slidesPerView: 1,
    autoHeight: true,
    a11y: true,
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true
    },
    preloadImages: false,
    watchSlidesProgress: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    on: {
      // Slow browsers don't update the height when the image loads
      lazyImageLoad: function(swiper, slideEl, imageEl) {
        if(swiper.__initialHeightFixed) {
          return
        }
        imageEl.addEventListener('load', e => {
          swiper.updateAutoHeight()
          swiper.__initialHeightFixed = true
        })
      },
    }
  };
  for (const [i, slider] of heroes.entries()) {
    const autoplay = parseInt(slider.getAttribute('data-hero-autoplay'))
    if (autoplay) {
      options = {
        ...options,
        autoplay: {
          delay: autoplay
        }
      }
    }
    // Prevent this from initializing multiple times from multiple hero sections on the same page
    if(slider.hasAttribute('hero-loaded')) {
      continue
    }
    slider.setAttribute('hero-loaded', '1')
    heroSliders[i] = new Swiper(slider, options);
  }

  playButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const slide = btn.closest('.swiper-slide')
      const video = slide.querySelector('video')
      slide.classList.add('video-active')
      video.play()
    })
  })
})